import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController } from "@ionic/angular";
import { OptionPhotoModel } from "src/app/models/option-photo.model";
import { ModelLocatorService } from "../config/model-locator.service";
import { ImageService } from "../image-service/image.service";
import { MessageService } from "../message-service/message.service";
import { SafetyService } from "./safety.service";

@Injectable()
export class ValidateIdentityService {


    constructor(private imageService: ImageService,
        private messageService: MessageService,
        private alertController: AlertController,
        private router: Router,
        private modelLocator: ModelLocatorService,
        private safetyService: SafetyService) {

    }

    async validateIdentity() {
        return new Promise(async (resolve) => {
            if (this.modelLocator.dadosLogin.documentacao === -1) {
                resolve({ message: 'Documentação Liberada!', status: 200 });
                return;
            }

            if (!await this.checkExistIdentityToValidate()) {
                resolve({ message: 'Documentação Pendente!', status: 404 });
                return;
            }

            if (!await this.imageService.checkCameraAvailability()) {
                this.messageService.showToast('Você não tem camera!', 'danger', 'bottom', 5000, true);
                resolve({ message: 'Sem câmera!', status: 404 });
                return;
            }


            let optionPhoto = new OptionPhotoModel;
            optionPhoto.title = 'Selfie de verificação!';
            optionPhoto.positionCamera = 'front';
            optionPhoto.frameToUse = 'frame_profile';
            optionPhoto.showPreviewImage = false;
            return await this.imageService.touchTakePhoto(optionPhoto).then(async (res: any) => {
                if (res != null && res.data != undefined) {
                    const convertImage = this.imageService.base64ToBlob(res.data, 'image/jpeg');
                    await this.safetyService.sendImgToRekognition(convertImage).then(async (response: any) => {
                        if (response['status'] != 200) {
                            let msg = 'Olá ' + this.modelLocator.dadosLogin.nome + '! <br><br> <b>Não conseguimos validar sua identidade!</b>';

                            let buttons = [{
                                text: 'Voltar',
                                cssClass: 'primary',
                                handler: () => {
                                }
                            }]

                            this.presentAlertConfirm(msg, buttons);
                            resolve(response);
                        } else {
                            this.messageService.showToast('Validação OK!', 'success', 'bottom', 5000, true);
                            resolve(response);
                        }
                    });
                } else {
                    let msg = 'Olá ' + this.modelLocator.dadosLogin.nome + '! <br><br> <b>Não conseguimos validar sua identidade!</b>';

                    let buttons = [{
                        text: 'Voltar',
                        cssClass: 'primary',
                        handler: () => {
                        }
                    }]

                    this.presentAlertConfirm(msg, buttons);
                    resolve({ message: 'Usuário cancelou o reconhecimento!', status: 404 });
                }
            }).catch((error) => {
                console.log("🚀 ~ file: validate-identity.service.ts:57 ~ ValidateIdentityService ~ awaitthis.imageService.touchTakePhoto ~ error:", error);
                resolve({ message: 'Erro ao tentar realizar reconhecimento!', status: 404 });
            });
        });
    }

    /**
     * Checks exist identity to validate
     * @author Starley Cazorla
     * @returns exist identity to validate
     */
    async checkExistIdentityToValidate(): Promise<boolean> {
        const allowedStatus = [3, 4];

        if (allowedStatus.includes(this.modelLocator.dadosLogin.documentacao)) {
            return true;
        } else {
            let msg = 'Você ainda não possui uma validação de identidade! <br><br> <b>Crie agora sua Face ID para deixar seus resgates mais seguros!</b>';

            let buttons = [
                {
                    text: 'Voltar',
                    handler: () => {
                    }
                },
                {
                    text: 'Enviar documentação',
                    cssClass: 'primary',
                    handler: () => {
                        this.router.navigate(['/face-register']);
                    }
                }]

            await this.presentAlertConfirm(msg, buttons);

            return false;
        }
    }

    async presentAlertConfirm(msg: string, buttons: any = []) {
        const alert = await this.alertController.create({
            header: 'Atenção!',
            message: msg,
            mode: 'md',
            backdropDismiss: false,
            buttons: buttons

        });

        await alert.present();
    }

}
